import { supabase } from '../supabase';

export interface StripeIncoming {
  date: string;
  amount_cents: number;
}

export interface StripePayoutRow {
  id: string;
  amount_cents: number;
  currency: string;
  status: string;
  arrival_date: string | null;
  bank_name: string | null;
  last4: string | null;
}

export interface StripeBalanceOverview {
  currency: string;
  availableCents: number;
  pendingCents: number;
  instantAvailableCents: number;
  incoming: StripeIncoming[];
  payouts: StripePayoutRow[];
}

export async function fetchStripeBalanceOverview(businessId: string): Promise<StripeBalanceOverview | null> {
  const { data, error } = await supabase.functions.invoke('get-stripe-balance-overview', {
    body: { businessId },
  });
  if (error || !data || data.error) return null;
  return {
    currency: data.currency || 'USD',
    availableCents: Number(data.availableCents) || 0,
    pendingCents: Number(data.pendingCents) || 0,
    instantAvailableCents: Number(data.instantAvailableCents) || 0,
    incoming: Array.isArray(data.incoming) ? data.incoming : [],
    payouts: Array.isArray(data.payouts) ? data.payouts : [],
  };
}
